
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs,
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ql-fill",attrs:{"d":"M15 8h-2a1 1 0 010-2h2a1 1 0 010 2zM15 12h-2a1 1 0 010-2h2a1 1 0 010 2zM15 16H5a1 1 0 010-2h10a1 1 0 010 2zM15 4H5a1 1 0 010-2h10a1 1 0 010 2z"}}),_c('rect',{staticClass:"ql-fill",attrs:{"x":"2","y":"6","width":"8","height":"6","rx":"1","ry":"1"}})])
          )
        }
      }
    